import { Form, Input, Button, Breadcrumb } from 'antd';
import { useForgotPassword } from '@hooks/useForgotPassword';
import { MailOutlined, HomeOutlined } from '@ant-design/icons';
import Link from '@components/ui/Link';
import { Container, AuthCard, BreadcrumbWrapper, MessageText } from '../style';

const ForgotPassword = () => {
    const { form, loading, submitted, onFinish } = useForgotPassword();

    const breadcrumbItems = [
        {
            title: (
                <Link to="/sign-in">
                    <HomeOutlined /> Sign In
                </Link>
            ),
        },
        { title: '' },
    ];

    if (submitted) {
        return (
            <Container>
                <AuthCard title="Forgot Password">
                    <BreadcrumbWrapper>
                        <Breadcrumb items={breadcrumbItems} />
                    </BreadcrumbWrapper>
                    <MessageText>Redirecting to OTP verification…</MessageText>
                </AuthCard>
            </Container>
        );
    }

    return (
        <Container>
            <AuthCard title="Forgot Password">
                <Form form={form} onFinish={onFinish} layout="vertical">
                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[{ required: true, message: 'Please input your email!' }]}
                    >
                        <Input size="large" prefix={<MailOutlined />} placeholder="E.G. yourname@example.com" />
                    </Form.Item>
                    <Form.Item>
                        <Button size="large" type="primary" htmlType="submit" block loading={loading}>
                            Send OTP
                        </Button>
                    </Form.Item>
                </Form>
            </AuthCard>
            <BreadcrumbWrapper>
                <Breadcrumb items={breadcrumbItems} />
            </BreadcrumbWrapper>
        </Container>
    );
};

export default ForgotPassword;
